export function createBooleanField(fieldName) {
    return {
      get() {
        return !!this.datoUsuario[fieldName];
      },
      set(value) {
        this.datoUsuario[fieldName] = value ? 1 : 0;
      }
    };
  }  